/**
 * IST (Asia/Kolkata, UTC+5:30) date/time utilities.
 * All admin UI date logic should go through these helpers so the app
 * behaves correctly regardless of where the browser is running.
 */

const TZ = 'Asia/Kolkata';

/** Today's date as YYYY-MM-DD in IST */
export function todayIST() {
  return new Date().toLocaleDateString('en-CA', { timeZone: TZ });
}

/** Current wall-clock hour (0–23) in IST */
export function currentISTHour() {
  const h = new Date().toLocaleString('en-US', { timeZone: TZ, hour: 'numeric', hour12: false });
  return parseInt(h, 10);
}

/**
 * A plain JS Date whose *local* fields (getFullYear, getMonth, getDate, getDay)
 * reflect IST wall-clock time. Useful for date arithmetic (start of week/month/quarter).
 */
export function nowIST() {
  const s = new Date().toLocaleString('en-US', { timeZone: TZ });
  return new Date(s);
}

/** Format a YYYY-MM-DD string for display, e.g. "25 May" */
export function fmtDateIST(iso) {
  return new Date(iso + 'T12:00:00+05:30').toLocaleDateString('en-IN', {
    day: 'numeric', month: 'short', timeZone: TZ,
  });
}

/** Shift a YYYY-MM-DD string by delta days, returning a new YYYY-MM-DD */
export function shiftDayIST(iso, delta) {
  const d = new Date(iso + 'T12:00:00+05:30');
  d.setDate(d.getDate() + delta);
  return d.toLocaleDateString('en-CA', { timeZone: TZ });
}

/** Format a ISO datetime string (created_at etc.) for display in IST */
export function fmtDateTimeIST(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-IN', {
    timeZone: TZ,
    day: 'numeric', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true,
  });
}
